import { EyeOutlined } from '@ant-design/icons'
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import Button from '../../../Components/Button'
import TableBox from '../../../Components/TableBox/TableBox'
import FilterLayout from '../../../Layout/FilterLayout'
import TableLayout from '../../../Layout/TableLayout'
import apiClient from '../../../Util/apiClient'
import { ORDER_TYPES } from '../../../Util/Options'
import { GET_DATA, SET_DATA, validateAccess } from '../../../Util/Util'
import GoodsIssueFilter from './GoodsIssueFilter'

export default function GoodsIssues() {
  const [goodsIssues, setGoodsIssues] = useState([])
  const history = useHistory()

  const getData = (params) => {
    const filterCache = GET_DATA('goodsIssues.filterData') || {}
    params = { ...filterCache, ...params }

    apiClient.get('goods-issues', { params }).then(({ status, data }) => {
      if (status === 200) {
        SET_DATA('goodsIssues.filterData', { ...params, ...data.pageData })
        setGoodsIssues(data.result)
      }
    })
  }

  useEffect(() => {
    getData()
  }, [])

  const columns = [
    {
      title: 'Transaction no.',
      dataIndex: 'transactionNo'
    },
    {
      title: 'Transaction Date',
      dataIndex: 'createdAt',
      render: (date) => moment(date).format('YYYY-MM-DD')
    },
    {
      title: 'Order Type',
      dataIndex: 'orderType',
      render: (value) => ORDER_TYPES.find((item) => item.value === value)?.label
    },
    {
      title: 'Order No.',
      dataIndex: 'orderNo'
    },
    {
      title: 'Requester',
      dataIndex: 'requester'
    },
    {
      title: 'Status',
      dataIndex: 'status'
    },
    {
      ...(validateAccess('view-goods-issue') && {
        title: 'Action',
        dataIndex: 'custom_action',
        render: (text, row) => (
          <div className="btn-group">
            <Button
              onClick={() => history.push(`/app/view-goods-issue/${row.id}`)}
              className="dropdown-toggle">
              <EyeOutlined />
            </Button>
          </div>
        )
      })
    }
  ]

  return (
    <FilterLayout
      addButton={{
        title: 'Goods issue',
        onClick: () => history.push('/app/add-goods-issue'),
        access: 'add-goods-issue'
      }}
      filterData={GET_DATA('goodsIssues.filterData')}
      filter={<GoodsIssueFilter onSubmit={getData} />}>
      <TableLayout title="Goods Issue Overview" detailed exportUrl="goods-issues/export">
        <TableBox
          dataSource={goodsIssues}
          columns={columns}
          pageData={GET_DATA('goodsIssues.filterData')}
          onChangePage={getData}
        />
      </TableLayout>
    </FilterLayout>
  )
}
